import $ from 'jquery';
import 'jquery.mmenu/dist/jquery.mmenu.all';
import './mobile.scss';

$(() => {
    let menuElement = $('[id="menu"]');
    let clone = menuElement.clone();
    let logoClone = $('.js-menu-logo').clone();
    let socialmediaClone = $('#bottom .socialmedia').clone();

    clone.attr('id', 'mmenu');
    clone.find('.icon', '.dropdown').remove();

    clone.mmenu({
        extensions: [
            'pagedim-black',
            'position-front',
            'fx-listitems-slide',
        ],
    }, {
        //
    });

    clone.find('#mm-1 .mm-navbar__title').text('').append(logoClone);
    clone.find('#mm-1').append(socialmediaClone);

    const api = clone.data('mmenu');
    const hamburger = document.querySelector('.hamburger');

    api.bind('open:start', () => {
        setTimeout(() => {
            $(hamburger).addClass('is-active');
        }, 100);
    });

    api.bind('close:start', () => {
        setTimeout(() => {
            $(hamburger).removeClass('is-active');
        }, 100);
    });

    clone.on('click', 'a.mm-listitem__text', () => {
        api.close()
    })
});
